/**
 * Use configured offences, or the original offence for an open-ended period.
 * Selected definitions use their stable ID. Older rules retain text matching.
 * @param {Object|string} offence Recorded Mention, or legacy offence text.
 * @param {Object} rule Configured rule.
 * @param {Object|null} period Existing accountability period.
 * @return {boolean} Whether the offence belongs to this process.
 */
export function matchesAccountabilityOffence(offence, rule, period = null) {
  const configured = rule.triggerOffenses || [];
  const targets = configured.length ? configured :
    period?.triggeringOffenseText ? [period.triggeringOffenseText] : [];
  if (!targets.length) return true;
  const record = offence && typeof offence === "object" ? offence : null;
  const id = record?.offenceId || record?.offenseId;
  const recordedText = record ? record.offence || record.offense ||
    record.reason || record.offenseName : offence;
  const text = String(recordedText || "").toLowerCase();
  return targets.some((target) => {
    if (id && target === id) return true;
    const value = String(target).toLowerCase();
    return Boolean(text && value &&
      (text.includes(value) || value.includes(text)));
  });
}
